import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	fetchProcesses: ({ plantCd, urlSearchParams }) => {
		const uri = `${BASE_URL}/mapping/v1/plants/${plantCd}/processes?${urlSearchParams}`;
		const encoded = encodeURI(uri);
		return client
			.get(encoded)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchServiceKinds: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=SYSAREA`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPgmIds: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/programs`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchProcIdsByPgmId: ({ plantCd, pgmId }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/processes?pgmId=${pgmId}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchProcIds: ({ plantCd }) => {
		// TODO
		return client
			.get(`${BASE_URL}/process/v1/plants/${plantCd}/processes?currentPage=0&pageUnit=0`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	createMapping: ({ mapping }) => {
		const { plantCd, pgmId, procId } = mapping;
		return client
			.post(`${BASE_URL}/mapping/v1/status/1/plants/${plantCd}/programs/${pgmId}/processes/${procId}`, mapping)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	updateMapping: ({ mapping }) => {
		const { plantCd, pgmId, procId } = mapping;
		return client
			.post(`${BASE_URL}/mapping/v1/status/2/plants/${plantCd}/programs/${pgmId}/processes/${procId}`, mapping)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	deleteMapping: ({ plantCd, pgmId, procId }) => {
		const uri = `${BASE_URL}/mapping/v1/status/3/plants/${plantCd}/programs/${pgmId}/processes/${procId}`;
		const encoded = encodeURI(uri);
		return client
			.post(encoded)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchQueues: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/mapping/v1/plants/${plantCd}/queues`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPgmQueueMaps: ({ plantCd, pgmId, procId }) => {
		const uri = `${BASE_URL}/mapping/v1/plants/${plantCd}/programs/${pgmId}/processes/${procId}/pgmQueueMaps`;
		const encoded = encodeURI(uri);
		return client
			.get(encoded)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	updatePgmQueueMaps: ({ plantCd, pgmId, procId, pgmQueueMapList }) => {
		const uri = `${BASE_URL}/mapping/v1/status/2/plants/${plantCd}/programs/${pgmId}/processes/${procId}/pgmQueueMaps`;
		const encoded = encodeURI(uri);
		return client
			.post(encoded, pgmQueueMapList)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	deletePgmQueueMaps: ({ plantCd, pgmId, procId }) => {
		const uri = `${BASE_URL}/mapping/v1/status/3/plants/${plantCd}/programs/${pgmId}/processes/${procId}/pgmQueueMaps`;
		const encoded = encodeURI(uri);
		return client
			.post(encoded)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
